import PaginationContext from '@jetshop/core/components/Pagination/PaginationContext';
import formatMessage from '@jetshop/intl';
import { styled } from 'linaria/react';
import qs from 'qs';
import * as React from 'react';
import { useLocation } from 'react-router';
export const PaginationWrapper = /*#__PURE__*/styled('div')({
  name: "PaginationWrapper",
  class: "p1pbvqjk"
});

const Pagination = ({
  prevPage,
  nextPage,
  currentPage,
  totalPages,
  isFirstPage,
  isLastPage,
  hasPages,
  className = ''
}) => {
  const {
    queryParam
  } = React.useContext(PaginationContext);
  const location = useLocation();
  const currentLocation = qs.parse(typeof window === 'undefined' ? location.search : window.location.search, {
    ignoreQueryPrefix: true
  });
  const nextHref = location.pathname + qs.stringify(Object.assign(Object.assign({}, currentLocation), {
    [queryParam]: isLastPage ? currentPage : currentPage + 1
  }), {
    addQueryPrefix: true,
    encodeValuesOnly: true,
    skipNulls: true
  });
  const prevHref = location.pathname + qs.stringify(Object.assign(Object.assign({}, currentLocation), {
    [queryParam]: isFirstPage ? currentPage : currentPage - 1
  }), {
    addQueryPrefix: true,
    encodeValuesOnly: true,
    skipNulls: true
  });
  return hasPages && !isNaN(totalPages) ? React.createElement(PaginationWrapper, {
    className: className
  }, React.createElement("a", {
    href: prevHref,
    onClick: e => {
      e.preventDefault();
      prevPage();
    },
    "data-disabled": isFirstPage ? true : null
  }, formatMessage('Prev')), React.createElement("div", null, formatMessage(`Page {currentPage} of {totalPages}`, {
    currentPage,
    totalPages
  })), React.createElement("a", {
    href: nextHref,
    onClick: e => {
      e.preventDefault();
      nextPage();
    },
    "data-disabled": isLastPage ? true : null
  }, formatMessage('Next'))) : null;
};

export default Pagination;

require("../../../../.linaria-cache/node_modules/@jetshop/ui/Pagination/Pagination.linaria.css");